define(function (require) {

    var Multiselect = require("ui/multiselect/Multiselect");
    var MultiselectWithToggle = require("ui/multiselect-with-toggle/MultiselectWithToggle");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');

    var FilterItemMultiSelectionDropdownWithSearchViewController = BaseFilterItem.extend({
        ControllerName: 'FilterItemMultiSelectionDropdownWithSearchViewController',
        LPViewMap: {
            searchDropdownSelection: ".lpview_search_dropdown_selection",
            fullTableContainer: "list_table_container",
            listContainer: "list-container"
        },
        LPTemplatesFiles: {
            filterSearchDropdownSelection: "LP_filter_search_dropdown_selection_view.html"
        },

        initialize: function (constructorData) {
            this.wrapper = constructorData.context;
            this.filterDataModelPath = constructorData.filterDataModelPath;
            this.publishProperty = constructorData.publishProperty || "id";
            this.textProperty = constructorData.textProperty || "name";
            this.titleText = "filter_title_" + constructorData.filterTextSuffix;
            this.minusOneData = constructorData.minusOneData || null;
            this.floating = constructorData.floating || false;
            this.toggleButton = constructorData.toggleButton;
            this.label = constructorData.label;
            this.toggleActivated = false;
            this.selectedItems = [];

            this.viewInit();
        },
        events: function () {
        },

        render: function () {
            this.multiselect.render();
        }
    });

    FilterItemMultiSelectionDropdownWithSearchViewController.prototype.viewInit = function () {
        var tableTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.filterSearchDropdownSelection);
        this.createView({template: tableTemplate});
        var dropdownContainer = this.getFirstElement(this.LPViewMap.searchDropdownSelection);
        var multiselectComponent = Multiselect;
        var multiselectConfigData = {
            container: $(dropdownContainer),
            trim: true,
            items: [],
            floating: this.floating || false,
            selectedItems: [],
            list: {
                maxShownItems: 5,
                noItems: {
                    visible: true,
                    value: this.noResultsText
                }
            },
            tagsContainer: {
                placeholder: this.translate(this.titleText),
                maxShownLines: 5,
                inlineErrorText: "",
                tagMaxWidth: "150px"
            }
        };
        if (this.label) {
            multiselectComponent = MultiselectWithToggle;
            _.assign(multiselectConfigData, {
                toggleButton: this.toggleButton && {
                    enabled: this.toggleButton.enabled || true,
                    checked: this.toggleButton.checked || false,
                    tooltip: {
                        active: this.toggleButton.tooltip && this.toggleButton.tooltip.active,
                        inactive: this.toggleButton.tooltip && this.toggleButton.tooltip.inactive
                    },
                    commitStateChange: false
                },
                label: this.label
            });
        }
        this.multiselect = new multiselectComponent(multiselectConfigData);
        this.multiselect.on(ToggleButton.TRIGGERING.CHANGE, this._onToggleChanged, this);
        this.multiselect.on(Multiselect.TRIGGERING.SELECT,this._onActionSelected,this);
        this.multiselect.on(Multiselect.TRIGGERING.UNSELECT,this._onActionUnselected,this);
        this.multiselect.on(Multiselect.TRIGGERING.FOCUS,this._onActionFocused,this);
    };

    FilterItemMultiSelectionDropdownWithSearchViewController.prototype._onToggleChanged = function (isActivated) {
        this.toggleActivated = isActivated;
        this.updateFilterUI(this.selectedItems.join(','));
        this.multiselect.uiComponents.toggleButton.toggle();
    };

    FilterItemMultiSelectionDropdownWithSearchViewController.prototype._onActionSelected = function(actionId) {
        this.selectedItems.push(actionId.id);
    };

    FilterItemMultiSelectionDropdownWithSearchViewController.prototype._onActionUnselected = function(actionId) {
        var position = this.selectedItems.indexOf(actionId.id);
        if (position !== -1) {
            this.selectedItems.splice(position, 1);
        }
    };

    //scroll down if there is not enough space
    FilterItemMultiSelectionDropdownWithSearchViewController.prototype._onActionFocused = function() {
        if(this.wrapper) {
            var container = this.wrapper.view.getElementsByClassName(this.LPViewMap.fullTableContainer)[0];
            var containerRect = container.getBoundingClientRect();
            var thisRect = this.view.getBoundingClientRect();

            var dropdownHeight = this.view.getElementsByClassName(this.LPViewMap.listContainer)[0].scrollHeight;

            if( (containerRect.bottom - thisRect.bottom) < dropdownHeight){
                container.scrollTop += dropdownHeight;
            }
        }
    };

    FilterItemMultiSelectionDropdownWithSearchViewController.prototype.getValue = function () {
        return (this.selectedItems.length > 0) ? this.selectedItems.toString() : undefined;
    };

    FilterItemMultiSelectionDropdownWithSearchViewController.prototype.getLatestItems = function () {
        this.controllerModelParam = App.agentController.getModelParam(this.filterDataModelPath);

        var list = this.controllerModelParam ? lpUtils.cloneObject(this.controllerModelParam) : [];
        if (this.minusOneData) {
            list.unshift(lpUtils.cloneObject(this.minusOneData));
        }

        if (this.toggleButton && this.toggleButton.toggleByField) {
            var toggleByField = this.toggleButton.toggleByField;
            _.forEach(list, function (el) {
                if (el[toggleByField.fieldName]) {
                    el.subText = toggleByField.lineSubText;
                }
            });

            if (!this.toggleActivated) {
                list = _.filter(list, function (el) {
                    return !el[toggleByField.fieldName];
                });
            }
        }

        var self= this;
        list = _.map(list, function(item) {
            var itemToReturn = {
                id: item[self.publishProperty],
                value: item[self.textProperty]
            };

            if (self.toggleButton && self.toggleButton.toggleByField && item[self.toggleButton.toggleByField.fieldName]) {
                itemToReturn.subText = self.toggleButton.toggleByField.lineSubText;
            }
            return itemToReturn;
        });

        return list;
    };

// set the tags and dropdown according to the data in the filter
    FilterItemMultiSelectionDropdownWithSearchViewController.prototype.updateFilterUI = function (filterUIData) {
        var itemIdsArray;
        var list = [];
        //clear all tags and selected items
        this.multiselect.clearInputValue();
        this.multiselect.unselectAll();
        this.selectedItems = [];

        //set the items list from model
        list = this.getLatestItems();
        this.multiselect.setItems(list);

        //set the relevant tags and selected items
        var self = this;
        if(filterUIData) {
            itemIdsArray = filterUIData.split(',');
            _.forEach(itemIdsArray, function(itemId) {
                if (_.find(list, function (el) { return el.id == itemId; })) {
                    itemId = parseInt(itemId, 10) ? parseInt(itemId, 10) : itemId; //if the id is number convert it to int otherwise take it as string
                    self._onActionSelected({id: itemId});
                    self.multiselect.select(itemId);
                }
            });
        }
    };

    return FilterItemMultiSelectionDropdownWithSearchViewController;
});
